import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

const ConditionalRoute: FC<ConditionalRouteProps> = ({
  condition,
  redirectTo,
  children,
}) => {
  console.log('🔍 ConditionalRoute:', {
    condition,
    redirectTo,
    currentPath: window.location.pathname,
    isConstructorPage: window.location.pathname.startsWith('/constructor')
  });

  // Для страницы конструктора добавляем дополнительную логику
  if (window.location.pathname.startsWith('/constructor')) {
    console.log('🔍 ConditionalRoute: On constructor page, checking for saved data...');

    // Проверяем, есть ли сохраненные данные конструктора
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('authData_')) {
        try {
          const data = localStorage.getItem(key);
          if (data) {
            const parsed = JSON.parse(data);
            if (parsed?.gameKey) {
              console.log('🔍 ConditionalRoute: Found constructor data, allowing access');
              return <>{children}</>;
            }
          }
        } catch (error) {
          console.error('Error parsing constructor data in ConditionalRoute:', error);
        }
      }
    }

    // Проверяем флаги
    const justSaved = localStorage.getItem('justSavedConstructorData');
    if (justSaved === 'true') {
      console.log('🔍 ConditionalRoute: Just saved constructor data, allowing access');
      return <>{children}</>;
    }
  }

  return condition ? <>{children}</> : <Navigate to={redirectTo} replace />;
};

export type ConditionalRouteProps = {
  condition: boolean
  redirectTo: string
  children?: ReactNode,
};

export default ConditionalRoute;
